import { Injectable } from '@angular/core';

@Injectable()
export class BdbDeviceIdService {

    constructor(
    ) {}

    getDeviceId() {
        return (window as any).rsaFunc();
    }
}



// WEBPACK FOOTER //
// ./src/app/shared/bdb-device-id.service.ts